import React, {} from 'react';
import { makeStyles } from '@material-ui/styles';

import { Modal, Backdrop, Fade} from '@material-ui/core';

const useStyles = makeStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
     
      borderRadius: 10,
      position: 'absolute',
      backgroundColor: "#FFFFFF",
    },
});

const CModal = (props) => {
    const classes = useStyles();
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={props.open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={props.open}>
                <div className={classes.paper} style={{...props.style, width: props.modalWidth || 880, height: props.modalHeight || 550}}>
                    { props.children }
                </div>
            </Fade>
        </Modal>
    );
}

export default CModal;